import * as DashboardApi from "../../../../apiCall/dashboard/index.js";
import * as constants from "../../widgetConstants.js";
import {getNoData, ttl2text} from "../../items/index.js";
import {subscribeWidget} from "../../../main-socket/index.js";
import Widget from "../widget.js";
import {WIDGET} from "../../widgetConstants.js";
import {readTargetRecord} from "../../../../indexedDB/index.js";
import u from "../../../../util/index.js";

export class BookmarkWidget extends Widget {

    async setup(props) {
        return super.setup(props);
    }

    async getData() {
        const inputData = {
            ...this.$props.pageData,
            GUBUN: "BOOKMARK",
            TMPL_TYPE: "",
        }
        return await super.checkDataVersion(inputData)
    }

    async getDBData(inputData) {
        const data = await DashboardApi.getApi(this.$props.API_KEY, inputData)
        this.$props.pageData.NEXT_YN = u.n2v(data.NEXT_YN, "N");
        return {
            recordData: data[this.$props.RECORD]
        };
    }
    async render() {
        $(this.$target).empty();
        $(this.$target).drawListHelper({
            pageData: this.$props.pageData,
            nextYn: this.$props.pageData.NEXT_YN,
            records: this.$props.data,
            noDataHtml: getNoData('bookmark'),
            callback: {
                item: getBookmarkPostsHtmByRecord,
                final: this.mounted.bind(this)
            }
        })
    }

    mounted() {
        super.mounted();
        $(this.$target).find('.widget-article-list').removeClass('dash-pending')
        $(this.$target).find('.dash-num-pending').remove()
        subscribeWidget({
            USER_ID : _USER_ID,
            TYPE : WIDGET.BOOKMARK.SRNO
        })
    }

}

/*북마크 아이템 dom으로 변환하여 반환하는 함수*/
const getBookmarkPostsHtmByRecord = (allPostsArray) => {
    return allPostsArray.map((item) => {
        item.COMMT_TTL = ttl2text(item.COMMT_TTL);
        return getBookmarkItem(item);
    }).join('');
}

/* 북마크 아이템 단건으로 li 반환*/

const getBookmarkItem = (item) => {
    let {
        COLABO_COMMT_SRNO = "",
        COLABO_SRNO = "",
        COLABO_REMARK_SRNO = "",
        TMPL_TYPE = "1",
        COMMT_TTL = ""
    } = item
    const tag2html = Mutil.tag2html(COMMT_TTL);
    return `<li id="allPosts-${COLABO_COMMT_SRNO}" colabo_srno="${COLABO_SRNO}" colabo_commt_srno="${COLABO_COMMT_SRNO}" colabo_remark_srno="${COLABO_REMARK_SRNO}" class="js-all-post-item">
                <span class="article-icon-wrap"><i class="icons-${DetailCode.POST._GB[TMPL_TYPE]}"></i></span>
                <p class="js-mouseover js-over-tooltip" mouseover-text="${tag2html}">${tag2html}</p>
            </li>`
}
